/*
 *
 * ProfileLeader constants
 *
 */

export const GET_PLANS_WATCHER = "app/ProfileLeader/GET_PLANS_WATCHER"
export const GET_PLANS_FAILED = "app/ProfileLeader/GET_PLANS_FAILED"
export const GET_PLANS_SUCCESS = "app/ProfileLeader/GET_PLANS_SUCCESS"

export const UPDATE_PHOTO_WATCHER = "app/ProfileLeader/UPDATE_PHOTO_WATCHER"
export const UPDATE_PHOTO_FAILED = "app/ProfileLeader/UPDATE_PHOTO_FAILED"
export const UPDATE_PHOTO_SUCCESS = "app/ProfileLeader/UPDATE_PHOTO_SUCCESS"
